const ALERT_MESSAGES = {
  PHONE_NOT_VERIFIED:
    "Your phone number isn't verified, please do by clicking on this text",
  EMAIL_NOT_VERIFIED:
    "Your email isn't verified, please do it by clicking on this text",
}

export default ALERT_MESSAGES
